import { AddMaterialForm } from "@/components/Materials/Forms/AddMaterialForm";
import { Modal } from "@/ui";

interface AddMaterialModalProps {
  show: boolean;
  onClose: () => void;
}

export const AddMaterialModal = ({ show, onClose }: AddMaterialModalProps) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Add Material"
      description="Create a new material (PDF or video)"
    >
      <AddMaterialForm onClose={onClose} />
    </Modal>
  );
};
